/**
 * This file is necessary because we cannot keep this in Auth0Utils
 */

export const PREFIX_FOR_CODE = 'AUTH0_CODE:';

export function isCode(fragmentOrCode: string): boolean {
  return !!fragmentOrCode && fragmentOrCode.startsWith(PREFIX_FOR_CODE);
}

export function removePrefixForCode(code: string): string {
  return code.slice(PREFIX_FOR_CODE.length);
}

export function addPrefixForCode(code: string): string {
  return `${PREFIX_FOR_CODE}${code}`;
}
